import { render, staticRenderFns } from "./DatosBancarios.vue?vue&type=template&id=9341ab70&scoped=true&"
import script from "./DatosBancarios.vue?vue&type=script&lang=js&"
export * from "./DatosBancarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9341ab70",
  null
  
)

export default component.exports